import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { FiltersService } from 'src/app/filters/filters.service';

@Injectable()
export class ServiceBase {
  baseUrl: string;
  identityUrl: string;
  clientId: string;
  clientSecret: string;
  grantType: string;
  page: {
    index: 0;
    size: 50000;
    sort: {
      fields: ['category_name'];
      direction: 'asc';
    };
  };

  constructor(public translateService: TranslateService) {
    this.baseUrl = environment.apiUrl.endsWith('/')
      ? environment.apiUrl
      : `${environment.apiUrl}/`;
    this.clientId = environment.clientId;
  }

  getLabelTranslation = (value: string, replacements?: Array<any>) => {
    let translated = this.translateService.instant(`main.labels.${value}`);
    if (replacements && replacements.length) {
      replacements.forEach((r, index) => {
        const replaceString = `%%${index}`;
        translated = translated.replace(replaceString, r);
      });
    }

    return translated;
  };

  getProductSortTranslation = (value: string, replacements?: Array<any>) => {
    return this.translateService.instant(`main.product_sort.${value}`);
  };

  getApiVersionHeader = (): HttpHeaders => {
    const headers = new HttpHeaders();
    headers.set('x-version', '2.0');
    return headers;
  };

  getPostBody = (
    clientId: number,
    customerIds?: Array<number>,
    branchIds?: Array<number>,
    regionIds?: Array<number>,
    districtIds?: Array<number>
  ): any => {
    const body = <any>{
      BranchList: [],
    };

    if (environment.softwareVersion) {
      body.SoftwareVersion = environment.softwareVersion;
    }

    body.ClientId = clientId;
    body.IncludeTotalsRow = true;
    if (customerIds) {
      body.CustomersList = customerIds;
    }

    if (branchIds && branchIds.length) {
      body.BranchList = branchIds;
    }

    if (regionIds && regionIds.length) {
      body.RegionList = regionIds;
    }

    if (districtIds && districtIds.length) {
      body.DistrictList = districtIds;
    }

    return body;
  };
}
